// ── L'onglet sur lequel s'ouvre le panneau du support (A2, chantier ASI) ──
export type SupportTab = 'assistant' | 'new' | 'list';

/** Une reponse du support non lue : « Mes demandes », comme avant ; sinon l'assistant s'il est offert */
export const defaultTab = ({ assistant, unread }: { assistant: boolean; unread: number }): SupportTab =>
  unread > 0 ? 'list' : assistant ? 'assistant' : 'new';
